// Inline icons for the file pickers. Both glyphs are drawn in the same 16×16 box,
// with the same 1.6 stroke and the LITERALLY identical arrow path, so the pair
// reads as one set rather than two icons that happen to sit together. They replace
// a bare "↑" character, which said the same thing on both buttons and so could not
// distinguish choosing files from choosing a folder — the one thing these two
// controls differ in.
//
// Sized in `em`, not px: the same markup is used in the comparison pane (10.5px
// mono) and on the Parquet viewer page (12.5px), and an icon that tracks its own
// button's text keeps the alignment right on both without a second rule.
const ARROW = 'M8 12.6V8.2M6 10.2 8 8.2l2 2';

const icon = (body) =>
  `<svg class="btn-icon" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${body}<path d="${ARROW}"/></svg>`;

// A sheet with a folded corner.
export const FILE_ICON = icon(
  '<path d="M4 14.6a1.4 1.4 0 0 1-1.4-1.4V2.8A1.4 1.4 0 0 1 4 1.4h4.6L13.4 6.2v7a1.4 1.4 0 0 1-1.4 1.4z"/><path d="M8.6 1.4v3.4a1.4 1.4 0 0 0 1.4 1.4h3.4"/>',
);

// The same sheet's outline logic applied to a tabbed folder.
export const FOLDER_ICON = icon(
  '<path d="M1.8 13.1V3.6a1.3 1.3 0 0 1 1.3-1.3h3.4l1.7 1.9h4.7a1.3 1.3 0 0 1 1.3 1.3v7.6a1.3 1.3 0 0 1-1.3 1.3H3.1a1.3 1.3 0 0 1-1.3-1.3z"/>',
);
